export const FETCH_STATS_INTERVAL = 1000 * 60 * 3; // 3 minutes
